import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';


export default function VehicleBasicInfoComponent({ vehicleBodyTypes, vehicleCategories, handleInnerFormChange, selectedVehicle, transporters, transportAgents }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Transporter Name"
              labelField="UserName"
              list={transporters}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TransporterId'

                );
              }}
              optionName='Choose Transporter'
              type="select"
              value={selectedVehicle?.TransporterId}
              valueField="Id"
            />
            <InputContainer
              label="Transporter Agent Name"
              labelField="Name"
              list={transportAgents}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TransportAgentId'

                );
              }}
              optionName='Choose TransporterAgent'
              type="select"
              value={selectedVehicle?.TransportAgentId}
              valueField="Id"
            />
            <InputContainer
              label="Vehicle Category"
              labelField="LogisticsVehicleCategoryName"
              list={vehicleCategories}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'LogisticsVehicleCategoryId'

                );
              }}
              optionName='Choose VehicleCategory'
              type="select"
              value={selectedVehicle?.LogisticsVehicleCategoryId}
              valueField="Id"
            />
            <InputContainer
              label="Vehicle Name"
              name="VehicleName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'VehicleName'

                )
              }}
              type="text"
              value={selectedVehicle?.VehicleName}
            />
            <InputContainer
              label="Vehicle BodyType"
              labelField="Text"
              list={vehicleBodyTypes}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'VehicleBodyTypeId'

                );
              }}
              optionName='Choose Body Type'
              type="select"
              value={selectedVehicle?.VehicleBodyTypeId}
              valueField="Value"
            />
            <InputContainer

              label="Registration Number"
              name="RegistrationNumber"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'RegistrationNumber'

                )
              }}
              type="text"
              value={selectedVehicle?.RegistrationNumber}
            />

            <InputContainer

              label="Vehicle Weight"
              name="VehicleWeight"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'VehicleWeight'

                )
              }}
              type="number"
              value={selectedVehicle?.VehicleWeight}
            />
            <InputContainer

              label="Loading Capacity"
              name="LoadingCapacity"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'LoadingCapacity'

                )
              }}
              type="number"
              value={selectedVehicle?.LoadingCapacity}
            />

            <InputContainer

              label="Vehicle Price"
              name="Price"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Price'

                )
              }}
              type="number"
              value={selectedVehicle?.Price}
            />
            <InputContainer

              label="Trip Base Price"
              name="Price"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TripVehicleBasePrice'

                )
              }}
              type="number"
              value={selectedVehicle?.TripVehicleBasePrice}
            />
            <InputContainer

              label="Trip Distance Base km"
              name="TripDistanceLimit"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TripDistanceLimit'

                )
              }}
              type="number"
              value={selectedVehicle?.TripDistanceLimit}
            />
            <div className='col-span-full'>
              <InputContainer

                label="Description"
                name="VehicleDescription"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'VehicleDescription'

                  )
                }}
                type="text"
                value={selectedVehicle?.VehicleDescription}
              />
            </div>
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Vehicle Information"
      />
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Length(meters)"
              name="Length"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Length'

                )
              }}
              type="number"
              value={selectedVehicle?.Length}
            />
            <InputContainer
              label="Width(meters)"
              name="Width"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Width'

                )
              }}
              type="number"
              value={selectedVehicle?.Width}
            />
            <InputContainer
              label="Height(meters)"
              name="Height"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Height'

                )
              }}
              type="number"
              value={selectedVehicle?.Height}
            />
          </div>
        }
        expandedPanel="dimensionsInfo"
        headerTitle="Dimensions Information"
      />

    </>
  )
}